import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

import SuspenseRouter from "./components/SuspenseRouter";
import "./App.scss";

import AuthProvider from "./context/AuthContext";
import RouteAuth from "./components/RouteAuth";
import ToastProvider from "./context/ToastContext";

const Login = lazy(() => import("./screens/Login"));
const DocumentoAssinado = lazy(() => import("./screens/DocumentoAssinado"));
const Dashboard = lazy(() => import("./screens/Dashboard"));
const Chamada = lazy(() => import("./screens/Chamada"));
const ChamadaConvidado = lazy(() => import("./screens/ChamadaConvidado"));
const ChamadaMobile = lazy(() => import("./screens/ChamadaMobile"));
const Assembleias = lazy(() => import("./screens/Assembleias"));
const Assembleia = lazy(() => import("./screens/Assembleia"));
const AssembleiaFormulario = lazy(() => import("./screens/AssembleiaFormulario"));
const AssembleiasPublicas = lazy(() => import("./screens/AssembleiasPublicas"));
const AssembleiasCredenciadas = lazy(() => import("./screens/AssembleiasCredenciadas"));
const AssembleiaCredenciada = lazy(() => import("./screens/AssembleiaCredenciada"));
const AssembleiaCredenciamentoFormulario = lazy(() => import("./screens/AssembleiaCredenciamentoFormulario"));
const Homologacoes = lazy(() => import("./screens/Homologacoes"));
const Homologacao = lazy(() => import("./screens/Homologacao"));
const Alertas = lazy(() => import("./screens/Alertas"));
const AlertaFormulario = lazy(() => import("./screens/AlertaFormulario"));
const Acessos = lazy(() => import("./screens/Acessos"));
const Grupos = lazy(() => import("./screens/Grupos"));
const GrupoFormulario = lazy(() => import("./screens/GrupoFormulario"));
const Usuarios = lazy(() => import("./screens/Usuarios"));
const UsuarioFormulario = lazy(() => import("./screens/UsuarioFormulario"));
const ConfiguracoesEmpresas = lazy(() => import("./screens/ConfiguracoesEmpresas"));
const ConfiguracaoFormulario = lazy(() => import("./screens/ConfiguracaoFormulario"));
const PessoaFormulario = lazy(() => import("./screens/PessoaFormulario"));

function App() {
	return (
		<SuspenseRouter window={window} basename={process.env.PUBLIC_URL}>
			<AuthProvider>
				<ToastProvider>
					<Routes>
						<Route path="/" element={<Login />}>
							<Route index element={<Login />} />
							<Route path=":token" element={<Login />} />
						</Route>
						<Route path="/documentoAssinado" element={<DocumentoAssinado />} />
						<Route
							path="/dashboard"
							element={
								<RouteAuth>
									<Dashboard />
								</RouteAuth>
							}
						/>
						<Route
							path="/chamada/:assembleiaId/:atoId"
							element={
								<RouteAuth>
									<Chamada />
								</RouteAuth>
							}
						/>
						<Route path="/chamadaConvidado" element={<ChamadaConvidado />} />
						<Route path="/chamadaMobile" element={<ChamadaMobile />}>
							<Route index element={<ChamadaMobile />} />
							<Route path=":grupoId" element={<ChamadaMobile />} />
						</Route>
						<Route
							path="/assembleias"
							element={
								<RouteAuth>
									<Assembleias />
								</RouteAuth>
							}
						/>
						<Route
							path="/assembleia/:id"
							element={
								<RouteAuth>
									<Assembleia />
								</RouteAuth>
							}
						/>
						<Route
							path="/assembleiaFormulario"
							element={
								<RouteAuth>
									<AssembleiaFormulario />
								</RouteAuth>
							}
						>
							<Route
								index
								element={
									<RouteAuth>
										<AssembleiaFormulario />
									</RouteAuth>
								}
							/>
							<Route
								path=":id"
								element={
									<RouteAuth>
										<AssembleiaFormulario />
									</RouteAuth>
								}
							/>
						</Route>
						<Route path="/assembleiasPublicas/:status" element={<AssembleiasPublicas />} />
						<Route
							path="/assembleiasCredenciadas"
							element={
								<RouteAuth>
									<AssembleiasCredenciadas />
								</RouteAuth>
							}
						/>
						<Route
							path="/assembleiaCredenciada/:id"
							element={
								<RouteAuth>
									<AssembleiaCredenciada />
								</RouteAuth>
							}
						/>
						<Route
							path="/assembleiaCredenciamentoFormulario"
							element={
								<RouteAuth>
									<AssembleiaCredenciamentoFormulario />
								</RouteAuth>
							}
						>
							<Route
								index
								element={
									<RouteAuth>
										<AssembleiaCredenciamentoFormulario />
									</RouteAuth>
								}
							/>
							<Route
								path=":id"
								element={
									<RouteAuth>
										<AssembleiaCredenciamentoFormulario />
									</RouteAuth>
								}
							/>
						</Route>
						<Route
							path="/homologacoes"
							element={
								<RouteAuth>
									<Homologacoes />
								</RouteAuth>
							}
						/>
						<Route
							path="/homologacao/:id"
							element={
								<RouteAuth>
									<Homologacao />
								</RouteAuth>
							}
						/>
						<Route
							path="/alertas"
							element={
								<RouteAuth>
									<Alertas />
								</RouteAuth>
							}
						/>
						<Route
							path="/alertaFormulario"
							element={
								<RouteAuth>
									<AlertaFormulario />
								</RouteAuth>
							}
						>
							<Route
								index
								element={
									<RouteAuth>
										<AlertaFormulario />
									</RouteAuth>
								}
							/>
							<Route
								path=":id"
								element={
									<RouteAuth>
										<AlertaFormulario />
									</RouteAuth>
								}
							/>
						</Route>
						<Route
							path="/acessos"
							element={
								<RouteAuth>
									<Acessos />
								</RouteAuth>
							}
						/>
						<Route
							path="/grupos"
							element={
								<RouteAuth>
									<Grupos />
								</RouteAuth>
							}
						/>
						<Route
							path="/grupoFormulario"
							element={
								<RouteAuth>
									<GrupoFormulario />
								</RouteAuth>
							}
						>
							<Route
								index
								element={
									<RouteAuth>
										<GrupoFormulario />
									</RouteAuth>
								}
							/>
							<Route
								path=":id"
								element={
									<RouteAuth>
										<GrupoFormulario />
									</RouteAuth>
								}
							/>
						</Route>
						<Route
							path="/usuarios"
							element={
								<RouteAuth>
									<Usuarios />
								</RouteAuth>
							}
						/>
						<Route
							path="/usuarioFormulario"
							element={
								<RouteAuth>
									<UsuarioFormulario />
								</RouteAuth>
							}
						>
							<Route
								index
								element={
									<RouteAuth>
										<UsuarioFormulario />
									</RouteAuth>
								}
							/>
							<Route
								path=":id"
								element={
									<RouteAuth>
										<UsuarioFormulario />
									</RouteAuth>
								}
							/>
						</Route>
						<Route
							path="/configuracoesEmpresas"
							element={
								<RouteAuth>
									<ConfiguracoesEmpresas />
								</RouteAuth>
							}
						/>
						<Route
							path="/configuracaoFormulario"
							element={
								<RouteAuth>
									<ConfiguracaoFormulario />
								</RouteAuth>
							}
						>
							<Route
								index
								element={
									<RouteAuth>
										<ConfiguracaoFormulario />
									</RouteAuth>
								}
							/>
							<Route
								path=":empresaId"
								element={
									<RouteAuth>
										<ConfiguracaoFormulario />
									</RouteAuth>
								}
							/>
						</Route>
						<Route
							path="/pessoaFormulario"
							element={
								<RouteAuth>
									<PessoaFormulario />
								</RouteAuth>
							}
						/>
					</Routes>
				</ToastProvider>
			</AuthProvider>
		</SuspenseRouter>
	);
}

export default App;
